import script from "./ProjectWork.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectWork.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectWork.vue?vue&type=style&index=0&id=5613b450&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5613b450"]])

export default __exports__